// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1CJJr","header":"PatientBlock_header__5uk5X","label":"PatientBlock_label__peNWz","option":"PatientBlock_option__1NNoj"};